import * as React from 'react';

import gql from 'graphql-tag';

import Course from 'bundles/degree-home/components/Course';
import Loader from 'bundles/degree-home/components/Loader';
import NoActiveCoursesMessage from 'bundles/degree-home/components/NoActiveCoursesMessage';
import type { LearningSequenceElement } from 'bundles/degree-home/types/Degree';

type Props = {
  degreeId: string;
  loading: boolean;
  learningSequenceElements?: Array<LearningSequenceElement>;
};

const DegreeCoursesList = (props: Props): JSX.Element => {
  const { loading, degreeId, learningSequenceElements } = props;

  if (loading) {
    return <Loader />;
  }
  if (learningSequenceElements && learningSequenceElements.length) {
    return (
      <ul className="rc-DegreeCoursesList nostyle">
        {learningSequenceElements.map((element) => {
          const { course } = element;
          return <Course key={course.id} course={course} degreeId={degreeId} />;
        })}
      </ul>
    );
  } else {
    return <NoActiveCoursesMessage />;
  }
};
DegreeCoursesList.fragment = gql`
  fragment DegreeCoursesListFragment on DegreeLearnerProgressesV1 {
    learningSequenceElements {
      ...DegreeCourseFragment
    }
  }
`;

export default DegreeCoursesList;
